// Copy multilingua (IT/EN/FR/DE/ES) per le pagine pubbliche Lounge.
// Isolato dall'i18n globale: le pagine restano standalone ma seguono la stessa
// lingua globale (useI18n().lang) e il LangSwitcher condiviso.

const COPY = {
  it: {
    nav_press: "Press & Media",
    nav_ambassador: "Ambassador",
    nav_portal: "Portale B2B",
    nav_lang_hint_press: "Seleziona la lingua e scarica i materiali",
    nav_lang_hint_ambassador: "Seleziona la lingua e entra nel team",
    // Press hero
    press_eyebrow: "Press & Media Lounge",
    press_title: "Lo spazio stampa di Brema 1969",
    press_sub: "Comunicati, materiale fotografico e catalogo per giornalisti, testate e media partner.",
    // Ambassador hero
    amb_eyebrow: "Ambassador Lounge",
    amb_title: "Corri con i colori di Brema",
    amb_sub: "Entra nella famiglia di atleti e content creator che rappresentano il marchio su strada, gravel e sterrato.",
    cta_material: "Richiedi materiale",
    cta_press: "Vai ai comunicati",
    cta_apply: "Diventa Ambassador",
    cta_kit: "Richiedi il kit",
    // Brand intro
    story_title: "La storia",
    story_p: "Dal 1969 Brema disegna e produce abbigliamento tecnico per chi vive la bici come una passione totale. Cinquant'anni di artigianalità italiana, cuciti in ogni capo.",
    perf_title: "Performance",
    perf_p: "Tessuti ad alta densità, vestibilità aerodinamica e ricerca continua sui materiali: ogni collezione nasce alla prova dei professionisti, in gara e in allenamento.",
    life_title: "Lifestyle",
    life_p: "Più di un capo tecnico: uno stile. Brema accompagna gli appassionati dalla partenza all'after-ride, con un'identità riconoscibile e senza tempo.",
    gallery_title: "Il mondo Brema in immagini",
    // Catalog
    catalog_title: "Catalogo",
    catalog_sub: "Sfoglia le collezioni. Consultazione libera, senza prezzi.",
    catalog_badge: "Senza prezzi",
    sizes: "Taglie",
    colors: "Colori",
    empty_catalog: "Catalogo in aggiornamento.",
    // Press releases
    releases_title: "Comunicati stampa",
    releases_sub: "Scarica i comunicati ufficiali e il materiale fotografico correlato.",
    download_pdf: "Scarica PDF",
    download_zip: "Scarica foto (ZIP)",
    media_title: "Libreria multimediale",
    media_sub: "Immagini e video ufficiali pronti per la pubblicazione.",
    media_sections: { "Prodotti": "Prodotti", "Brand & Heritage": "Brand & Heritage", "Video": "Video" },
    video_badge: "Video",
    // Ambassadors
    ambassadors_title: "I nostri Ambassador",
    ambassadors_sub: "Atleti e creator che portano Brema in ogni disciplina.",
    // Forms
    material_title: "Proposta di interesse — materiale e campioni",
    material_sub: "Compila il modulo: ti ricontatteremo per concordare l'invio.",
    apply_title: "Diventa Ambassador",
    apply_sub: "Raccontaci chi sei e quali discipline pratichi.",
    kit_title: "Richiesta Kit Ambassador",
    kit_sub: "Richiedi il kit ufficiale: la spedizione sarà concordata con l'amministrazione.",
    kit_guidelines_title: "Linee guida Brema per gli Ambassador",
    kit_guidelines: [
      "Rappresenta i valori del marchio con correttezza e sportività.",
      "Utilizza e mostra i capi Brema durante allenamenti, gare ed eventi.",
      "Cita @brema.bike e usa l'hashtag ufficiale nei contenuti social.",
      "Ogni fornitura di kit e materiale è concordata previo contatto diretto con l'amministrazione.",
    ],
    f_name: "Nome e cognome",
    f_email: "Email",
    f_org: "Testata / Organizzazione",
    f_items: "Materiale richiesto",
    f_social: "Profilo social",
    f_outlet: "Testata / Nome Media",
    material_rules_title: "Regole per la richiesta di materiale",
    f_discipline: "Disciplina",
    f_address: "Indirizzo di spedizione",
    f_message: "Messaggio",
    submit: "Invia richiesta",
    sending: "Invio in corso…",
    success: "Richiesta inviata. Ti ricontatteremo a breve.",
    error: "Invio non riuscito. Riprova.",
    disclaimer: "Le richieste di campioni e materiale inviate rappresentano una proposta d'interesse. Ogni invio verrà concordato e confermato previo contatto diretto con la nostra amministrazione.",
    ref_note: "Richiesta collegata a:",
    footer_rights: "Tutti i diritti riservati.",
    footer_press: "Ufficio stampa",
    contact_btn: "Contattaci",
    contact_title: "Scrivi all'azienda",
    contact_sub_press: "Domande, proposte o richieste particolari? Scrivi direttamente all'ufficio stampa Brema 1969: il messaggio arriva in azienda e ti risponderemo via email.",
    contact_sub_ambassador: "Domande, proposte o richieste particolari? Scrivi direttamente al team Brema 1969: il messaggio arriva in azienda e ti risponderemo via email.",
    f_subject: "Oggetto",
    contact_send: "Invia messaggio",
    contact_ok: "Messaggio inviato. Ti risponderemo via email.",
    contact_required: "Compila nome, email e messaggio.",
    // Selezione campioni
    samples_eyebrow: "Campionatura",
    samples_title: "Selezione campioni",
    samples_sub: "Sfoglia le collezioni e componi la tua proposta di campionatura.",
    select_size: "Taglia",
    sizes_none: "Taglia unica",
    add_to_selection: "Aggiungi",
    panel_title: "La tua selezione campioni",
    panel_empty: "Nessun capo selezionato. Aggiungi articoli dal catalogo.",
    contact_heading: "I tuoi dati",
    f_company: "Ragione Sociale / Nominativo",
    f_phone: "Telefono",
    sample_submit: "Invia Proposta di Campionatura",
    sample_added: "Aggiunto alla selezione",
    sample_need_items: "Aggiungi almeno un capo alla selezione.",
    fill_required: "Compila tutti i campi obbligatori.",
    select_size_ph: "Seleziona taglia",
    select_size_toast: "Seleziona una taglia.",
    detail_title: "Scheda prodotto",
    category_label: "Categoria",
    line_label: "Linea",
    code_label: "Codice articolo",
    gender_label: "Genere",
    description_label: "Descrizione",
    tech_label: "Caratteristiche tecniche",
    no_description: "Nessuna descrizione disponibile.",
    zoom_hint: "Ingrandisci",
    auto_translated: "tradotto automaticamente",
    translating: "traduzione in corso…",
    media_preview: "Vedi anteprima",
    media_download: "Scarica",
    read_more: "Leggi tutto",
    copy_text: "Copia testo",
    copied: "Testo copiato negli appunti",
    copy_failed: "Copia non riuscita. Riprova.",
    download_official_pdf: "Scarica PDF Ufficiale",
    press_contacts: "Contatti stampa",
    release_detail_title: "Comunicato stampa",
    sub_title: "Aggiornamenti stampa",
    sub_desc: "Sei una testata? Lascia la tua email per ricevere i nuovi comunicati Brema.",
    sub_email_ph: "La tua email",
    sub_outlet_ph: "Testata / Media (facoltativo)",
    sub_btn: "Iscriviti",
    sub_ok: "Iscrizione registrata. Grazie!",
    sub_err_email: "Inserisci un'email valida.",
    sub_check_email: "Ti abbiamo inviato una mail: conferma l'iscrizione per completare.",
    sub_already: "Sei già iscritto. Preferenze aggiornate!",
    release_gallery_title: "Galleria media",
    presentation_images_title: "Immagini di presentazione",
    download_hd: "Scarica HD",
    download_all_zip: "Scarica tutto (ZIP)",
    confirm_title: "Iscrizione stampa",
    confirm_loading: "Conferma in corso…",
    confirm_ok: "Iscrizione confermata!",
    confirm_ok_desc: "Riceverai i nuovi comunicati stampa di Brema 1969 nella tua lingua.",
    confirm_err: "Link non valido o già confermato.",
    confirm_cta: "Vai alla Press Lounge",
  },
  en: {
    nav_press: "Press & Media",
    nav_ambassador: "Ambassador",
    nav_portal: "B2B Portal",
    nav_lang_hint_press: "Select your language and download the materials",
    nav_lang_hint_ambassador: "Select your language and join the team",
    press_eyebrow: "Press & Media Lounge",
    press_title: "The Brema 1969 press space",
    press_sub: "Press releases, photo assets and catalogue for journalists, magazines and media partners.",
    amb_eyebrow: "Ambassador Lounge",
    amb_title: "Ride in Brema colours",
    amb_sub: "Join the family of athletes and creators who represent the brand on road, gravel and trail.",
    cta_material: "Request materials",
    cta_press: "Go to press releases",
    cta_apply: "Become an Ambassador",
    cta_kit: "Request the kit",
    story_title: "The story",
    story_p: "Since 1969 Brema has designed and produced technical apparel for those who live cycling as a total passion. Fifty years of Italian craftsmanship, sewn into every garment.",
    perf_title: "Performance",
    perf_p: "High-density fabrics, aerodynamic fit and constant material research: every collection is proven by professionals, in races and training.",
    life_title: "Lifestyle",
    life_p: "More than technical gear: a style. Brema follows riders from the start line to the after-ride, with a timeless, recognisable identity.",
    gallery_title: "The Brema world in pictures",
    catalog_title: "Catalogue",
    catalog_sub: "Browse the collections. Free to explore, no prices shown.",
    catalog_badge: "No prices",
    sizes: "Sizes",
    colors: "Colours",
    empty_catalog: "Catalogue is being updated.",
    releases_title: "Press releases",
    releases_sub: "Download official releases and the related photo material.",
    download_pdf: "Download PDF",
    download_zip: "Download photos (ZIP)",
    media_title: "Media library",
    media_sub: "Official images and videos ready for publication.",
    media_sections: { "Prodotti": "Products", "Brand & Heritage": "Brand & Heritage", "Video": "Video" },
    video_badge: "Video",
    ambassadors_title: "Our Ambassadors",
    ambassadors_sub: "Athletes and creators carrying Brema across every discipline.",
    material_title: "Expression of interest — material & samples",
    material_sub: "Fill in the form: we will contact you to arrange the shipment.",
    apply_title: "Become an Ambassador",
    apply_sub: "Tell us who you are and which disciplines you practise.",
    kit_title: "Ambassador Kit request",
    kit_sub: "Request the official kit: shipping will be arranged with our administration.",
    kit_guidelines_title: "Brema guidelines for Ambassadors",
    kit_guidelines: [
      "Represent the brand values with fairness and sportsmanship.",
      "Wear and show Brema gear during training, races and events.",
      "Tag @brema.bike and use the official hashtag in your content.",
      "Every kit and material supply is arranged after direct contact with our administration.",
    ],
    f_name: "Full name",
    f_email: "Email",
    f_org: "Magazine / Organisation",
    f_items: "Requested material",
    f_social: "Social profile",
    f_outlet: "Outlet / Media name",
    material_rules_title: "Material request rules",
    f_discipline: "Discipline",
    f_address: "Shipping address",
    f_message: "Message",
    submit: "Send request",
    sending: "Sending…",
    success: "Request sent. We will get back to you shortly.",
    error: "Sending failed. Please try again.",
    disclaimer: "Sample and material requests represent an expression of interest. Every shipment will be agreed and confirmed after direct contact with our administration.",
    ref_note: "Request linked to:",
    footer_rights: "All rights reserved.",
    footer_press: "Press office",
    contact_btn: "Contact us",
    contact_title: "Write to the company",
    contact_sub_press: "Questions, proposals or special requests? Write directly to the Brema 1969 press office: your message reaches the company and we will reply by email.",
    contact_sub_ambassador: "Questions, proposals or special requests? Write directly to the Brema 1969 team: your message reaches the company and we will reply by email.",
    f_subject: "Subject",
    contact_send: "Send message",
    contact_ok: "Message sent. We will reply by email.",
    contact_required: "Please fill in name, email and message.",
    // Sample selection
    samples_eyebrow: "Sampling",
    samples_title: "Sample selection",
    samples_sub: "Browse the collections and build your sampling proposal.",
    select_size: "Size",
    sizes_none: "One size",
    add_to_selection: "Add",
    panel_title: "Your sample selection",
    panel_empty: "No items selected yet. Add products from the catalogue.",
    contact_heading: "Your details",
    f_company: "Company name / Full name",
    f_phone: "Phone",
    sample_submit: "Send sampling proposal",
    sample_added: "Added to selection",
    sample_need_items: "Add at least one item to the selection.",
    fill_required: "Please fill in all required fields.",
    select_size_ph: "Select size",
    select_size_toast: "Please select a size.",
    detail_title: "Product sheet",
    category_label: "Category",
    line_label: "Line",
    code_label: "Article code",
    gender_label: "Gender",
    description_label: "Description",
    tech_label: "Technical details",
    no_description: "No description available.",
    zoom_hint: "Zoom",
    auto_translated: "auto-translated",
    translating: "translating…",
    media_preview: "Preview",
    media_download: "Download",
    read_more: "Read more",
    copy_text: "Copy text",
    copied: "Text copied to clipboard",
    copy_failed: "Copy failed. Please try again.",
    download_official_pdf: "Download official PDF",
    press_contacts: "Press contacts",
    release_detail_title: "Press release",
    sub_title: "Press updates",
    sub_desc: "Are you a media outlet? Leave your email to receive Brema's new press releases.",
    sub_email_ph: "Your email",
    sub_outlet_ph: "Outlet / Media (optional)",
    sub_btn: "Subscribe",
    sub_ok: "Subscription saved. Thank you!",
    sub_err_email: "Please enter a valid email.",
    sub_check_email: "We've sent you an email: confirm your subscription to complete.",
    sub_already: "You're already subscribed. Preferences updated!",
    release_gallery_title: "Media gallery",
    presentation_images_title: "Presentation images",
    download_hd: "Download HD",
    download_all_zip: "Download all (ZIP)",
    confirm_title: "Press subscription",
    confirm_loading: "Confirming…",
    confirm_ok: "Subscription confirmed!",
    confirm_ok_desc: "You'll receive Brema 1969's new press releases in your language.",
    confirm_err: "Invalid or already-confirmed link.",
    confirm_cta: "Go to Press Lounge",
  },
  fr: {
    nav_press: "Presse & Médias",
    nav_ambassador: "Ambassadeur",
    nav_portal: "Portail B2B",
    nav_lang_hint_press: "Choisissez la langue et téléchargez les contenus",
    nav_lang_hint_ambassador: "Choisissez la langue et rejoignez l'équipe",
    press_eyebrow: "Press & Media Lounge",
    press_title: "L'espace presse de Brema 1969",
    press_sub: "Communiqués, visuels et catalogue pour journalistes, magazines et partenaires médias.",
    amb_eyebrow: "Ambassador Lounge",
    amb_title: "Roulez aux couleurs de Brema",
    amb_sub: "Rejoignez la famille d'athlètes et de créateurs qui représentent la marque sur route, gravel et sentier.",
    cta_material: "Demander du matériel",
    cta_press: "Voir les communiqués",
    cta_apply: "Devenir Ambassadeur",
    cta_kit: "Demander le kit",
    story_title: "L'histoire",
    story_p: "Depuis 1969, Brema conçoit et fabrique des vêtements techniques pour ceux qui vivent le vélo comme une passion totale. Cinquante ans de savoir-faire italien, cousus dans chaque pièce.",
    perf_title: "Performance",
    perf_p: "Tissus à haute densité, coupe aérodynamique et recherche constante sur les matériaux : chaque collection est éprouvée par les professionnels, en course et à l'entraînement.",
    life_title: "Style de vie",
    life_p: "Plus qu'un vêtement technique : un style. Brema accompagne les cyclistes du départ à l'after-ride, avec une identité intemporelle et reconnaissable.",
    gallery_title: "L'univers Brema en images",
    catalog_title: "Catalogue",
    catalog_sub: "Parcourez les collections. Consultation libre, sans prix.",
    catalog_badge: "Sans prix",
    sizes: "Tailles",
    colors: "Couleurs",
    empty_catalog: "Catalogue en cours de mise à jour.",
    releases_title: "Communiqués de presse",
    releases_sub: "Téléchargez les communiqués officiels et le matériel photo associé.",
    download_pdf: "Télécharger le PDF",
    download_zip: "Télécharger les photos (ZIP)",
    media_title: "Médiathèque",
    media_sub: "Images et vidéos officielles prêtes à publier.",
    media_sections: { "Prodotti": "Produits", "Brand & Heritage": "Marque & Héritage", "Video": "Vidéo" },
    video_badge: "Vidéo",
    ambassadors_title: "Nos Ambassadeurs",
    ambassadors_sub: "Athlètes et créateurs qui portent Brema dans toutes les disciplines.",
    material_title: "Manifestation d'intérêt — matériel & échantillons",
    material_sub: "Remplissez le formulaire : nous vous contacterons pour organiser l'envoi.",
    apply_title: "Devenir Ambassadeur",
    apply_sub: "Dites-nous qui vous êtes et quelles disciplines vous pratiquez.",
    kit_title: "Demande de Kit Ambassadeur",
    kit_sub: "Demandez le kit officiel : l'envoi sera convenu avec notre administration.",
    kit_guidelines_title: "Lignes directrices Brema pour les Ambassadeurs",
    kit_guidelines: [
      "Représentez les valeurs de la marque avec fair-play et esprit sportif.",
      "Portez et montrez les produits Brema à l'entraînement, en course et lors d'événements.",
      "Mentionnez @brema.bike et utilisez le hashtag officiel dans vos contenus.",
      "Toute fourniture de kit et de matériel est convenue après contact direct avec notre administration.",
    ],
    f_name: "Nom et prénom",
    f_email: "Email",
    f_org: "Magazine / Organisation",
    f_items: "Matériel demandé",
    f_social: "Profil social",
    f_outlet: "Média / Nom du média",
    material_rules_title: "Règles pour la demande de matériel",
    f_discipline: "Discipline",
    f_address: "Adresse d'expédition",
    f_message: "Message",
    submit: "Envoyer la demande",
    sending: "Envoi…",
    success: "Demande envoyée. Nous vous recontacterons bientôt.",
    error: "Échec de l'envoi. Réessayez.",
    disclaimer: "Les demandes d'échantillons et de matériel constituent une manifestation d'intérêt. Chaque envoi sera convenu et confirmé après contact direct avec notre administration.",
    ref_note: "Demande liée à :",
    footer_rights: "Tous droits réservés.",
    footer_press: "Service de presse",
    contact_btn: "Contactez-nous",
    contact_title: "Écrire à l'entreprise",
    contact_sub_press: "Questions, propositions ou demandes particulières ? Écrivez directement au service de presse Brema 1969 : votre message parvient à l'entreprise et nous vous répondrons par e-mail.",
    contact_sub_ambassador: "Questions, propositions ou demandes particulières ? Écrivez directement à l'équipe Brema 1969 : votre message parvient à l'entreprise et nous vous répondrons par e-mail.",
    f_subject: "Objet",
    contact_send: "Envoyer le message",
    contact_ok: "Message envoyé. Nous vous répondrons par e-mail.",
    contact_required: "Renseignez le nom, l'e-mail et le message.",
    // Sélection d'échantillons
    samples_eyebrow: "Échantillons",
    samples_title: "Sélection d'échantillons",
    samples_sub: "Parcourez les collections et composez votre proposition d'échantillonnage.",
    select_size: "Taille",
    sizes_none: "Taille unique",
    add_to_selection: "Ajouter",
    panel_title: "Votre sélection d'échantillons",
    panel_empty: "Aucun article sélectionné. Ajoutez des produits depuis le catalogue.",
    contact_heading: "Vos coordonnées",
    f_company: "Raison sociale / Nom",
    f_phone: "Téléphone",
    sample_submit: "Envoyer la proposition d'échantillonnage",
    sample_added: "Ajouté à la sélection",
    sample_need_items: "Ajoutez au moins un article à la sélection.",
    fill_required: "Veuillez remplir tous les champs obligatoires.",
    select_size_ph: "Sélectionner la taille",
    select_size_toast: "Veuillez sélectionner une taille.",
    detail_title: "Fiche produit",
    category_label: "Catégorie",
    line_label: "Ligne",
    code_label: "Code article",
    gender_label: "Genre",
    description_label: "Description",
    tech_label: "Détails techniques",
    no_description: "Aucune description disponible.",
    zoom_hint: "Agrandir",
    auto_translated: "traduit automatiquement",
    translating: "traduction en cours…",
    media_preview: "Aperçu",
    media_download: "Télécharger",
    read_more: "Lire la suite",
    copy_text: "Copier le texte",
    copied: "Texte copié dans le presse-papiers",
    copy_failed: "Échec de la copie. Réessayez.",
    download_official_pdf: "Télécharger le PDF officiel",
    press_contacts: "Contacts presse",
    release_detail_title: "Communiqué de presse",
    sub_title: "Actualités presse",
    sub_desc: "Vous êtes un média ? Laissez votre e-mail pour recevoir les nouveaux communiqués Brema.",
    sub_email_ph: "Votre e-mail",
    sub_outlet_ph: "Média / Support (facultatif)",
    sub_btn: "S'inscrire",
    sub_ok: "Inscription enregistrée. Merci !",
    sub_err_email: "Veuillez saisir un e-mail valide.",
    sub_check_email: "Nous vous avons envoyé un e-mail : confirmez votre inscription pour finaliser.",
    sub_already: "Vous êtes déjà inscrit. Préférences mises à jour !",
    release_gallery_title: "Galerie média",
    presentation_images_title: "Images de présentation",
    download_hd: "Télécharger HD",
    download_all_zip: "Tout télécharger (ZIP)",
    confirm_title: "Inscription presse",
    confirm_loading: "Confirmation en cours…",
    confirm_ok: "Inscription confirmée !",
    confirm_ok_desc: "Vous recevrez les nouveaux communiqués de Brema 1969 dans votre langue.",
    confirm_err: "Lien invalide ou déjà confirmé.",
    confirm_cta: "Aller à la Press Lounge",
  },
  de: {
    nav_press: "Presse & Medien",
    nav_ambassador: "Ambassador",
    nav_portal: "B2B-Portal",
    nav_lang_hint_press: "Sprache wählen und Materialien herunterladen",
    nav_lang_hint_ambassador: "Sprache wählen und dem Team beitreten",
    press_eyebrow: "Press & Media Lounge",
    press_title: "Der Pressebereich von Brema 1969",
    press_sub: "Pressemitteilungen, Bildmaterial und Katalog für Journalisten, Magazine und Medienpartner.",
    amb_eyebrow: "Ambassador Lounge",
    amb_title: "Fahre in den Farben von Brema",
    amb_sub: "Werde Teil der Familie aus Athleten und Creators, die die Marke auf Straße, Gravel und Trail vertreten.",
    cta_material: "Material anfragen",
    cta_press: "Zu den Mitteilungen",
    cta_apply: "Ambassador werden",
    cta_kit: "Kit anfragen",
    story_title: "Die Geschichte",
    story_p: "Seit 1969 entwirft und fertigt Brema technische Bekleidung für alle, die Radsport als totale Leidenschaft leben. Fünfzig Jahre italienische Handwerkskunst, in jedes Kleidungsstück eingenäht.",
    perf_title: "Performance",
    perf_p: "Hochdichte Stoffe, aerodynamische Passform und ständige Materialforschung: Jede Kollektion wird von Profis im Rennen und Training erprobt.",
    life_title: "Lifestyle",
    life_p: "Mehr als technische Ausrüstung: ein Stil. Brema begleitet Fahrer vom Start bis zum After-Ride, mit einer zeitlosen, unverwechselbaren Identität.",
    gallery_title: "Die Welt von Brema in Bildern",
    catalog_title: "Katalog",
    catalog_sub: "Durchstöbere die Kollektionen. Frei einsehbar, ohne Preise.",
    catalog_badge: "Ohne Preise",
    sizes: "Größen",
    colors: "Farben",
    empty_catalog: "Katalog wird aktualisiert.",
    releases_title: "Pressemitteilungen",
    releases_sub: "Lade die offiziellen Mitteilungen und das zugehörige Bildmaterial herunter.",
    download_pdf: "PDF herunterladen",
    download_zip: "Fotos herunterladen (ZIP)",
    media_title: "Mediathek",
    media_sub: "Offizielle Bilder und Videos, bereit zur Veröffentlichung.",
    media_sections: { "Prodotti": "Produkte", "Brand & Heritage": "Marke & Erbe", "Video": "Video" },
    video_badge: "Video",
    ambassadors_title: "Unsere Ambassadors",
    ambassadors_sub: "Athleten und Creators, die Brema in jede Disziplin tragen.",
    material_title: "Interessenbekundung — Material & Muster",
    material_sub: "Fülle das Formular aus: Wir melden uns, um den Versand zu vereinbaren.",
    apply_title: "Ambassador werden",
    apply_sub: "Erzähl uns, wer du bist und welche Disziplinen du ausübst.",
    kit_title: "Ambassador-Kit anfragen",
    kit_sub: "Fordere das offizielle Kit an: Der Versand wird mit unserer Verwaltung vereinbart.",
    kit_guidelines_title: "Brema-Richtlinien für Ambassadors",
    kit_guidelines: [
      "Vertritt die Markenwerte fair und sportlich.",
      "Trage und zeige Brema-Ausrüstung bei Training, Rennen und Events.",
      "Markiere @brema.bike und nutze den offiziellen Hashtag in deinen Inhalten.",
      "Jede Lieferung von Kit und Material wird nach direktem Kontakt mit unserer Verwaltung vereinbart.",
    ],
    f_name: "Vor- und Nachname",
    f_email: "Email",
    f_org: "Magazin / Organisation",
    f_items: "Angefragtes Material",
    f_social: "Social-Profil",
    f_outlet: "Medium / Name des Mediums",
    material_rules_title: "Regeln für die Materialanfrage",
    f_discipline: "Disziplin",
    f_address: "Lieferadresse",
    f_message: "Nachricht",
    submit: "Anfrage senden",
    sending: "Wird gesendet…",
    success: "Anfrage gesendet. Wir melden uns in Kürze.",
    error: "Senden fehlgeschlagen. Bitte erneut versuchen.",
    disclaimer: "Muster- und Materialanfragen sind eine Interessenbekundung. Jeder Versand wird nach direktem Kontakt mit unserer Verwaltung vereinbart und bestätigt.",
    ref_note: "Anfrage verknüpft mit:",
    footer_rights: "Alle Rechte vorbehalten.",
    footer_press: "Pressestelle",
    contact_btn: "Kontakt",
    contact_title: "An das Unternehmen schreiben",
    contact_sub_press: "Fragen, Vorschläge oder besondere Anliegen? Schreiben Sie direkt an die Pressestelle von Brema 1969: Ihre Nachricht erreicht das Unternehmen und wir antworten per E-Mail.",
    contact_sub_ambassador: "Fragen, Vorschläge oder besondere Anliegen? Schreiben Sie direkt an das Brema 1969 Team: Ihre Nachricht erreicht das Unternehmen und wir antworten per E-Mail.",
    f_subject: "Betreff",
    contact_send: "Nachricht senden",
    contact_ok: "Nachricht gesendet. Wir antworten per E-Mail.",
    contact_required: "Bitte Name, E-Mail und Nachricht ausfüllen.",
    // Musterauswahl
    samples_eyebrow: "Muster",
    samples_title: "Musterauswahl",
    samples_sub: "Durchstöbere die Kollektionen und stelle deine Musteranfrage zusammen.",
    select_size: "Größe",
    sizes_none: "Einheitsgröße",
    add_to_selection: "Hinzufügen",
    panel_title: "Deine Musterauswahl",
    panel_empty: "Noch keine Artikel ausgewählt. Füge Produkte aus dem Katalog hinzu.",
    contact_heading: "Deine Daten",
    f_company: "Firma / Name",
    f_phone: "Telefon",
    sample_submit: "Musteranfrage senden",
    sample_added: "Zur Auswahl hinzugefügt",
    sample_need_items: "Füge mindestens einen Artikel zur Auswahl hinzu.",
    fill_required: "Bitte fülle alle Pflichtfelder aus.",
    select_size_ph: "Größe wählen",
    select_size_toast: "Bitte wähle eine Größe.",
    detail_title: "Produktdatenblatt",
    category_label: "Kategorie",
    line_label: "Linie",
    code_label: "Artikelnummer",
    gender_label: "Geschlecht",
    description_label: "Beschreibung",
    tech_label: "Technische Details",
    no_description: "Keine Beschreibung verfügbar.",
    zoom_hint: "Vergrößern",
    auto_translated: "automatisch übersetzt",
    translating: "wird übersetzt…",
    media_preview: "Vorschau",
    media_download: "Herunterladen",
    read_more: "Mehr lesen",
    copy_text: "Text kopieren",
    copied: "Text in die Zwischenablage kopiert",
    copy_failed: "Kopieren fehlgeschlagen. Bitte erneut versuchen.",
    download_official_pdf: "Offizielles PDF herunterladen",
    press_contacts: "Pressekontakte",
    release_detail_title: "Pressemitteilung",
    sub_title: "Presse-Updates",
    sub_desc: "Sind Sie ein Medium? Hinterlassen Sie Ihre E-Mail, um neue Brema-Pressemitteilungen zu erhalten.",
    sub_email_ph: "Ihre E-Mail",
    sub_outlet_ph: "Medium / Redaktion (optional)",
    sub_btn: "Abonnieren",
    sub_ok: "Anmeldung gespeichert. Danke!",
    sub_err_email: "Bitte geben Sie eine gültige E-Mail ein.",
    sub_check_email: "Wir haben Ihnen eine E-Mail gesendet: Bitte bestätigen Sie Ihr Abonnement.",
    sub_already: "Sie sind bereits angemeldet. Einstellungen aktualisiert!",
    release_gallery_title: "Mediengalerie",
    presentation_images_title: "Präsentationsbilder",
    download_hd: "HD herunterladen",
    download_all_zip: "Alle herunterladen (ZIP)",
    confirm_title: "Presse-Abonnement",
    confirm_loading: "Wird bestätigt…",
    confirm_ok: "Abonnement bestätigt!",
    confirm_ok_desc: "Sie erhalten die neuen Pressemitteilungen von Brema 1969 in Ihrer Sprache.",
    confirm_err: "Ungültiger oder bereits bestätigter Link.",
    confirm_cta: "Zur Press Lounge",
  },
  es: {
    nav_press: "Prensa & Medios",
    nav_ambassador: "Embajador",
    nav_portal: "Portal B2B",
    nav_lang_hint_press: "Selecciona el idioma y descarga los materiales",
    nav_lang_hint_ambassador: "Selecciona el idioma y únete al equipo",
    press_eyebrow: "Press & Media Lounge",
    press_title: "El espacio de prensa de Brema 1969",
    press_sub: "Comunicados, material fotográfico y catálogo para periodistas, revistas y socios de medios.",
    amb_eyebrow: "Ambassador Lounge",
    amb_title: "Rueda con los colores de Brema",
    amb_sub: "Únete a la familia de atletas y creadores que representan la marca en carretera, gravel y montaña.",
    cta_material: "Solicitar material",
    cta_press: "Ver comunicados",
    cta_apply: "Ser Embajador",
    cta_kit: "Solicitar el kit",
    story_title: "La historia",
    story_p: "Desde 1969 Brema diseña y produce ropa técnica para quienes viven el ciclismo como una pasión total. Cincuenta años de artesanía italiana, cosidos en cada prenda.",
    perf_title: "Rendimiento",
    perf_p: "Tejidos de alta densidad, ajuste aerodinámico e investigación constante de materiales: cada colección se prueba con profesionales, en competición y entrenamiento.",
    life_title: "Estilo de vida",
    life_p: "Más que ropa técnica: un estilo. Brema acompaña a los ciclistas desde la salida hasta el after-ride, con una identidad atemporal y reconocible.",
    gallery_title: "El mundo Brema en imágenes",
    catalog_title: "Catálogo",
    catalog_sub: "Explora las colecciones. Consulta libre, sin precios.",
    catalog_badge: "Sin precios",
    sizes: "Tallas",
    colors: "Colores",
    empty_catalog: "Catálogo en actualización.",
    releases_title: "Comunicados de prensa",
    releases_sub: "Descarga los comunicados oficiales y el material fotográfico relacionado.",
    download_pdf: "Descargar PDF",
    download_zip: "Descargar fotos (ZIP)",
    media_title: "Mediateca",
    media_sub: "Imágenes y vídeos oficiales listos para publicar.",
    media_sections: { "Prodotti": "Productos", "Brand & Heritage": "Marca y Legado", "Video": "Vídeo" },
    video_badge: "Vídeo",
    ambassadors_title: "Nuestros Embajadores",
    ambassadors_sub: "Atletas y creadores que llevan Brema a cada disciplina.",
    material_title: "Muestra de interés — material y muestras",
    material_sub: "Completa el formulario: te contactaremos para acordar el envío.",
    apply_title: "Ser Embajador",
    apply_sub: "Cuéntanos quién eres y qué disciplinas practicas.",
    kit_title: "Solicitud de Kit de Embajador",
    kit_sub: "Solicita el kit oficial: el envío se acordará con nuestra administración.",
    kit_guidelines_title: "Directrices de Brema para Embajadores",
    kit_guidelines: [
      "Representa los valores de la marca con juego limpio y deportividad.",
      "Usa y muestra el equipamiento Brema en entrenamientos, carreras y eventos.",
      "Menciona @brema.bike y usa el hashtag oficial en tus contenidos.",
      "Todo suministro de kit y material se acuerda tras contacto directo con nuestra administración.",
    ],
    f_name: "Nombre y apellidos",
    f_email: "Email",
    f_org: "Revista / Organización",
    f_items: "Material solicitado",
    f_social: "Perfil social",
    f_outlet: "Medio / Nombre del medio",
    material_rules_title: "Reglas para la solicitud de material",
    f_discipline: "Disciplina",
    f_address: "Dirección de envío",
    f_message: "Mensaje",
    submit: "Enviar solicitud",
    sending: "Enviando…",
    success: "Solicitud enviada. Te contactaremos pronto.",
    error: "Error al enviar. Inténtalo de nuevo.",
    disclaimer: "Las solicitudes de muestras y material representan una muestra de interés. Cada envío se acordará y confirmará tras contacto directo con nuestra administración.",
    ref_note: "Solicitud vinculada a:",
    footer_rights: "Todos los derechos reservados.",
    footer_press: "Oficina de prensa",
    contact_btn: "Contáctanos",
    contact_title: "Escribir a la empresa",
    contact_sub_press: "¿Preguntas, propuestas o solicitudes especiales? Escribe directamente a la oficina de prensa de Brema 1969: tu mensaje llega a la empresa y te responderemos por email.",
    contact_sub_ambassador: "¿Preguntas, propuestas o solicitudes especiales? Escribe directamente al equipo de Brema 1969: tu mensaje llega a la empresa y te responderemos por email.",
    f_subject: "Asunto",
    contact_send: "Enviar mensaje",
    contact_ok: "Mensaje enviado. Te responderemos por email.",
    contact_required: "Rellena nombre, email y mensaje.",
    // Selección de muestras
    samples_eyebrow: "Muestreo",
    samples_title: "Selección de muestras",
    samples_sub: "Explora las colecciones y compón tu propuesta de muestreo.",
    select_size: "Talla",
    sizes_none: "Talla única",
    add_to_selection: "Añadir",
    panel_title: "Tu selección de muestras",
    panel_empty: "Ningún artículo seleccionado. Añade productos del catálogo.",
    contact_heading: "Tus datos",
    f_company: "Razón social / Nombre",
    f_phone: "Teléfono",
    sample_submit: "Enviar propuesta de muestreo",
    sample_added: "Añadido a la selección",
    sample_need_items: "Añade al menos un artículo a la selección.",
    fill_required: "Rellena todos los campos obligatorios.",
    select_size_ph: "Seleccionar talla",
    select_size_toast: "Selecciona una talla.",
    detail_title: "Ficha de producto",
    category_label: "Categoría",
    line_label: "Línea",
    code_label: "Código de artículo",
    gender_label: "Género",
    description_label: "Descripción",
    tech_label: "Detalles técnicos",
    no_description: "No hay descripción disponible.",
    zoom_hint: "Ampliar",
    auto_translated: "traducido automáticamente",
    translating: "traduciendo…",
    media_preview: "Vista previa",
    media_download: "Descargar",
    read_more: "Leer más",
    copy_text: "Copiar texto",
    copied: "Texto copiado al portapapeles",
    copy_failed: "No se pudo copiar. Inténtalo de nuevo.",
    download_official_pdf: "Descargar PDF oficial",
    press_contacts: "Contactos de prensa",
    release_detail_title: "Comunicado de prensa",
    sub_title: "Novedades de prensa",
    sub_desc: "¿Eres un medio? Deja tu email para recibir los nuevos comunicados de Brema.",
    sub_email_ph: "Tu email",
    sub_outlet_ph: "Medio / Publicación (opcional)",
    sub_btn: "Suscribirse",
    sub_ok: "Suscripción registrada. ¡Gracias!",
    sub_err_email: "Introduce un email válido.",
    sub_check_email: "Te hemos enviado un email: confirma tu suscripción para completar.",
    sub_already: "Ya estás suscrito. ¡Preferencias actualizadas!",
    release_gallery_title: "Galería multimedia",
    presentation_images_title: "Imágenes de presentación",
    download_hd: "Descargar HD",
    download_all_zip: "Descargar todo (ZIP)",
    confirm_title: "Suscripción de prensa",
    confirm_loading: "Confirmando…",
    confirm_ok: "¡Suscripción confirmada!",
    confirm_ok_desc: "Recibirás los nuevos comunicados de Brema 1969 en tu idioma.",
    confirm_err: "Enlace no válido o ya confirmado.",
    confirm_cta: "Ir a la Press Lounge",
  },
};

export function loungeCopy(lang) {
  if (!lang || lang === "it" || !COPY[lang]) return COPY.it;
  return { ...COPY.it, ...COPY[lang] };
}

export default COPY;
